import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=2d88cb36&scoped=true"
import script from "./AlertContainer.js?vue&type=script&lang=js&external"
export * from "./AlertContainer.js?vue&type=script&lang=js&external"
import style0 from "./AlertContainer.scss?vue&type=style&index=0&id=2d88cb36&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88cb36",
  null
  
)

export default component.exports